export const BANNERS_WIDGET = 'podtatrze';
export const CAROUSEL_WIDGET = 'carousel_menu';
export const HORSE_RACING_WIDGET = 'racing-horse';
export const GREYHOUND_RACING_WIDGET = 'racing-greyhound';
export const BETFEED_WIDGET = 'betfeed_widget';
export const POPULAR_WIDGET = 'popular_events_widget';
export const INPLAY_WIDGET = 'homepage_featured_inplay';
export const BETFINDER_WIDGET = 'genius';
export const FOOTBALL_SPORT_WIDGET = 'football';
export const AMERICAN_FOOTBALL_SPORT_WIDGET = 'american-football';
export const BASEBALL_SPORT_WIDGET = 'baseball';
export const GAA_FOOTBALL_SPORT_WIDGET = 'gaa-football';
export const GAA_HURLING_SPORT_WIDGET = 'gaa-hurling';
export const RUGBY_LEAGUE_SPORT_WIDGET = 'rugby-league';
export const RUGBY_UNION_SPORT_WIDGET = 'rugby-union';
export const TENNIS_SPORT_WIDGET = 'tennis';
export const TABLE_TENNIS_SPORT_WIDGET = 'table-tennis';
export const DARTS_SPORT_WIDGET = 'darts';
export const CRICKET_SPORT_WIDGET = 'cricket';
export const SNOOKER_SPORT_WIDGET = 'snooker';
export const BASKETBALL_SPORT_WIDGET = 'basketball';
export const BOXING_SPORT_WIDGET = 'boxing';
export const MMA_SPORT_WIDGET = 'mma';
export const ICE_HOCKEY_SPORT_WIDGET = 'ice-hockey';
export const VOLLEYBALL_SPORT_WIDGET = 'volleyball';
export const HANDBALL_SPORT_WIDGET = 'handball';
export const ESPORTS_WIDGET = 'esports';
export const TROTTING_WIDGET = 'trotting';
export const BADMINTON_WIDGET = 'badminton';
export const AUSTRALIAN_RULES_WIDGET = 'australian-rules';
export const SPOTLIGHT_WIDGET = 'spotlight';
export const GOLF_SPORT_WIDGET = 'golf';
export const ARTICLE_WIDGET = 'long-article';

export const WORLDCUPHUB_WIDGET = 'world-cup-hub';

export const MADE_FOR_YOU_WIDGET = 'madeforyou';

export const ODDS_BOOST_WIDGET = 'odds_boost_widget';
export const XSELL_WIDGET = 'xsell_widget';
export const POKER_BLAST_WIDGET = 'poker_blast';

export const HOMEPAGE_LOCATION = 'homepage';
